import rozcestnikZememerictvi from '../../content/rozcestnik/rozcestnikZememerictvi.jsx';
import { initRozcestnik } from "./rozcestnikService.js";
import { renderLoginComponent } from "../../components/Login";
import { initRozcestnikUdaje } from "./rozcestnikUdajeService.js";
import { destroyElement } from "../../utils/common.mjs";

export function initRozcestnikZememerictvi(isPublic) {

    const tilesDiv = document.getElementById('tiles');
    tilesDiv.innerHTML = "";

    tilesDiv.appendChild(rozcestnikZememerictvi(isPublic));
    tilesDiv.style.display = 'block';
    
    const divFormio = document.querySelector('#divFormio');
    divFormio.style.display = "none";
    destroyElement('back-button-services');

    const home = document.getElementById('rozcestnikRoot');
    home.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnik(isPublic);
    });

    const udaje = document.getElementById('rozcestnikUdaje');
    udaje.addEventListener("click", event => {
        event.preventDefault();
        initRozcestnikUdaje(isPublic);
    });

    const geoportalLinkTile = document.getElementById("geoportal-link-tile");
    if (!isPublic && geoportalLinkTile) {
      geoportalLinkTile.setAttribute(
                "href", "/Geoportal"
      )
    }

    let rozcestnikZememerictviZmenaBodu = document.getElementById('rozcestnikZememerictviZmenaBodu');

    if (isPublic) {
        rozcestnikZememerictviZmenaBodu?.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S8008');
            
        });
    } else {
        rozcestnikZememerictviZmenaBodu?.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S8008', null, null);
            
        });
    }

    let rozcestnikZememerictviPremisteniBodu = document.getElementById('rozcestnikZememerictviPremisteniBodu');

    if (isPublic) {
        rozcestnikZememerictviPremisteniBodu?.addEventListener("click", event => {
            event.preventDefault();
            renderLoginComponent('S2448');
            
        });
    } else {
        rozcestnikZememerictviPremisteniBodu?.addEventListener("click", event => {
            event.preventDefault();
            window.initFormio('S2448', null, null);
            
        });
    }
}